import React, { useState } from 'react';
import { Modal } from 'antd';
import { Form } from 'antd';
import AddHttpToolForm from './AddHttpToolForm';
import AddMcpServerForm from './AddMcpServerForm';

export default function AddToolModal({
  open,
  type,
  onCancel,
  onCreateHttp,
  onCreateMcp,
}) {
  const [httpMode, setHttpMode] = useState('openapi');
  const [httpForm] = Form.useForm();
  const [mcpForm] = Form.useForm();

  const reset = () => {
    setHttpMode('openapi');
    httpForm.resetFields();
    mcpForm.resetFields();
  };

  const handleCancel = () => {
    reset();
    onCancel?.();
  };

  if (!type) return null;

  return (
    <Modal
      title={type === 'http' ? 'Add HTTP source' : 'Add MCP server'}
      open={open}
      onCancel={handleCancel}
      onOk={() => {
        if (type === 'http') httpForm.submit();
        else mcpForm.submit();
      }}
      okText="Create"
      width={640}
      destroyOnClose
    >
      {type === 'http' ? (
        <AddHttpToolForm
          form={httpForm}
          createMode={httpMode}
          onCreateModeChange={setHttpMode}
          onFinish={async (values) => {
            await onCreateHttp?.(values, httpMode);
            reset();
          }}
        />
      ) : (
        <AddMcpServerForm
          form={mcpForm}
          onFinish={async (values) => {
            await onCreateMcp?.(values);
            reset();
          }}
        />
      )}
    </Modal>
  );
}
